import(/* webpackMode: "eager" */ "D:\\b\\baczonedz\\src\\app\\tools\\pomodoro\\page.tsx");
